import { InputAdornment, TextField, withStyles } from '@material-ui/core';
import React, { useState } from 'react';
import flowRight from 'lodash.flowright';
import { connect } from 'react-redux';

import PrimaryButton from '../../../partials/customButtons/PrimaryButton';
import numberAvailabilityCheck from '../actions/numberAvailabilityCheck';
import fetchOperator from '../actions/fetchOperator';
import { isDefined, isUndefined } from '../../../utils/isDefined';
import { translate } from '../../../i18n/I18nProvider';
import Optional from '../../../utils/optional';
import RESPONSE_CODES from '../../../consts/responseCodes';
import styles from '../styles/portNumberCheck';
import { actions as reduxActions } from '../reducers';
import validateMobileNumber from '../actions/validateMobileNumber';

const PortNumberCheck = ({
  setFieldValue,
  classes,
  setUserData,
  setCheckNumberData
}) => {
  const [numberToCheck, setNumberToCheck] = useState('');
  const [numberError, setNumberError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const onCheckClick = async () => {
    setNumberError(null);

    const validation = validateMobileNumber(numberToCheck);

    if (!validation.isValid) {
      setNumberError(validation.error);
      return;
    }

    setIsLoading(true);

    try {
      const {
        isNumberAvailable,
        availabilityError
      } = await numberAvailabilityCheck(numberToCheck);

      if (!isNumberAvailable) {
        setNumberError(
          translate(
            Optional(availabilityError).or('REQUEST_NEW_USER.NUMBER_IN_USE')
          )
        );
        return;
      }

      if (isNumberAvailable) {
        const { data: checkNumberData, error } = await fetchOperator(
          `45${numberToCheck}`
        );

        if (isUndefined(error) && isDefined(checkNumberData)) {
          setFieldValue('mobile_number', `45${numberToCheck}`);
          setCheckNumberData(checkNumberData);
          setUserData(
            { current_operator: checkNumberData.servoper_N },
            'thirdStep'
          );
        } else {
          if (
            Optional(error.status)
              .map(status => status === RESPONSE_CODES.NOT_FOUND)
              .or(false)
          ) {
            setNumberError(translate('REQUEST_NEW_USER.INCORRECT_NUMBER'));
          }
        }
      }
    } catch (error) {
      console.error('Number check error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleNumberChange = e => {
    const value = e.target.value;
    setNumberToCheck(value);

    if (numberError) {
      setNumberError(null);
    }
  };

  const isButtonDisabled = !numberToCheck.trim() || isLoading;

  return (
    <div className={classes.root}>
      <p>{translate('REQUEST_NEW_USER.ENTER_NUMBER_TO_PORT')}</p>
      <div className={classes.row}>
        <TextField
          variant="outlined"
          margin="dense"
          onChange={handleNumberChange}
          value={numberToCheck}
          className={classes.textField}
          error={!!numberError}
          helperText={numberError}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">+45</InputAdornment>
            )
          }}
          inputProps={{
            autoComplete: 'off',
            'data-lpignore': true,
            maxLength: 8
          }}
          disabled={isLoading}
        />
        <PrimaryButton
          onClick={onCheckClick}
          disabled={isButtonDisabled}
          loading={isLoading}
        >
          {translate('CHECK')}
        </PrimaryButton>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  setUserData: reduxActions.setUserData,
  setCheckNumberData: reduxActions.setCheckNumberData
};

export default flowRight(
  connect(null, mapDispatchToProps),
  withStyles(styles)
)(PortNumberCheck);
